import { memo } from 'react';
import { AdvancedMarker, useMap } from '@vis.gl/react-google-maps';

import { MapCluster } from '@atom/types/map';

import { getGoogleShapeCenter } from '../mapUtilities';

import ClusterMarkerContent from './ClusterMarkerContent';
import { MARKER_STYLE, resolveAnchor, resolveZIndex } from './markerUtilities';

type ClusterMarkerProps = {
  cluster: MapCluster;
};

const ClusterMarker = ({ cluster }: ClusterMarkerProps) => {
  const map = useMap();
  const position = getGoogleShapeCenter(cluster.location);

  const handleClick = () => {
    if (!map) {
      return;
    }

    map.setZoom((map.getZoom() ?? 0) + 3);
    map.panTo(position);
  };

  return (
    <AdvancedMarker
      position={position}
      zIndex={resolveZIndex('cluster')}
      {...resolveAnchor('cluster')}
      style={MARKER_STYLE}
      onClick={handleClick}
    >
      <ClusterMarkerContent count={cluster.count} />
    </AdvancedMarker>
  );
};

export default memo(ClusterMarker);
